import { twMerge } from 'tailwind-merge';

import { CurrencyIcon } from '@/entities/currency/ui';

import { AllIcon, CheckIndicator } from '@/shared/assets';
import { ICurrencyAccount, cn } from '@/shared/lib';
import { Typography } from '@/shared/ui';
import { Soon } from '@/shared/ui/components/soon';

interface CurrencyAccountItemProps {
  item: ICurrencyAccount;
  className?: string;
  description?: string;
  isSelected?: boolean;
  onClick: (item: ICurrencyAccount) => void;
  disabled?: boolean;
  isSend?: boolean;
  isAll?: boolean;
}

export const CurrencyAccountItem = ({
  item,
  className,
  description,
  isSelected,
  onClick,
  disabled,
  isSend,
  isAll,
}: CurrencyAccountItemProps) => {
  return (
    <div
      className={cn(
        'grid grid-cols-[56px_1fr_max-content] items-center py-2',
        !disabled && 'cursor-pointer',
        className,
      )}
      onClick={() => {
        if (disabled) return;
        onClick(item);
      }}
    >
      <div className="relative h-[40px] w-[40px]">
        {isAll ? (
          <AllIcon className="h-[42px] w-[42px]" />
        ) : (
          <CurrencyIcon ticker={item.code} size="lg" />
        )}
        {isSelected && (
          <CheckIndicator className="absolute bottom-0 right-[-5px] h-4 w-4" />
        )}
      </div>

      <div className="flex flex-col gap-y-1">
        <Typography
          variant="16-r"
          className={twMerge('mr-2', disabled && isSend && 'text-base-100')}
        >
          {isAll ? 'All accounts' : item.currencyName}
        </Typography>
        {description && (
          <Typography variant="14-r" color="text-base-100">
            {description}
          </Typography>
        )}
      </div>

      <div className="flex flex-col gap-y-1">
        {disabled ? (
          <Soon
            text={isSend ? 'Unavailable' : 'Requested'}
            size={isSend ? 'sm' : 'xs'}
          />
        ) : (
          <Typography variant="16-r">
            {item.value}&#8239;{item.symbol}
          </Typography>
        )}
      </div>
    </div>
  );
};
